import { Component } from "react";

import PayementAvanceBillCheque from "./PayementAvanceBillCheque";
import PayementAvanceBillEnLigne from "./PayementAvanceBillEnLigne";
import PayementAvanceBillEspece from "./PayementAvanceBillEspece";
import PayementAvanceBillVirement from "./PayementAvanceBillVirement";
import PayementAvanceBillWallet from "./PayementAvanceBillWallet";
import PayementAvanceBillChequeFN from "./PayementAvanceBillChequeFN";
import PayementAvanceBillEnLigneFN from "./PayementAvanceBillEnLigneFN";
import PayementAvanceBillEspeceFN from "./PayementAvanceBillEspeceFN";
import PayementAvanceBillVirementFN from "./PayementAvanceBillVirementFN";
import PayementAvanceBillPrelevementFN from "./PayementAvanceBillPrelevementFN";

class MethodePayementBillAvance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      methodePayement: "",
    };
  }
  createUIPayement() {
    localStorage.setItem("restToPay",this.props.restToPay)

    if (this.state.methodePayement === "CHEQUE") {
      return <PayementAvanceBillChequeFN wallet={this.props.wallet} />;
    } else if (this.state.methodePayement === "ENLIGNE") {
      return <PayementAvanceBillEnLigneFN />;
    } else if (this.state.methodePayement === "ESPECE") {
      return <PayementAvanceBillEspeceFN />;
    } else if (this.state.methodePayement === "VIREMENT") {
      return <PayementAvanceBillVirementFN />;
    }else if (this.state.methodePayement === "WALLET") {
      return <PayementAvanceBillWallet />;
    }else if (this.state.methodePayement === "PRELEVEMENT") {
      return <PayementAvanceBillPrelevementFN />;
    }
  }
  listOptionsPayement = () => {
    if (this.props.typeWallet) {
      return (
        <select class="form-control" onChange={this.handleChangePayement}>
          <option key={0} value={0}>
            Sélectionner un mode de payement
          </option>
          <option key={1} value={"ESPECE"}>
            Espèce
          </option>
          <option key={2} value={"ENLIGNE"}>
            En ligne
          </option>
          <option key={3} value={"CHEQUE"}>
            Chèques / Traites
          </option>
          <option key={4} value={"VIREMENT"}>
            Virement
          </option>
          <option key={5} value={"WALLET"}>
            Wallet
          </option>
          <option key={6} value={"PRELEVEMENT"}>
          Prélèvement
          </option>
        </select>
      );
    } else {
      return (
        <select class="form-control" onChange={this.handleChangePayement}>
          <option key={0} value={0}>
            Sélectionner un mode de payement
          </option>
          <option key={1} value={"ESPECE"}>
            Espèce
          </option>
          <option key={2} value={"ENLIGNE"}>
            En ligne
          </option>
          <option key={3} value={"CHEQUE"}>
            Chèques / Traites
          </option>
          <option key={4} value={"VIREMENT"}>
            Virement
          </option>
          <option key={6} value={"PRELEVEMENT"}>
          Prélèvement
          </option>
        </select>
      );
    }
  };
  handleChangePayement = (e) => {
    let payement = e.target.value;
    this.setState({
      methodePayement: payement,
    });
  };
  render() {
    return (
      <div className="card-body">
        <h5 className="card-title">Choisir le mode de payement de l'avance </h5>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-10">
          {this.listOptionsPayement()}
          </div>
        </div>
        {this.createUIPayement()}
        <br />
        <br />
      </div>
    );
  }
}
export default MethodePayementBillAvance;
